function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import ComponentWrapper from "../ComponentWrapper";
import { MediaContextProvider } from "../ComponentWrapper/Media";
import FeedbackBackTop from "./backTop";
import FeedbackBtn from "./feedbackBtn";
import FeedbackPopover from "./feedbackPopover";
import "./style/index.css";
import { Popover } from 'antd';
import cx from 'classnames';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
var Feedback = function Feedback(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  var children = props.children,
    className = props.className,
    style = props.style,
    _props$haveBacktop = props.haveBacktop,
    haveBacktop = _props$haveBacktop === void 0 ? true : _props$haveBacktop,
    _props$fixed = props.fixed,
    fixed = _props$fixed === void 0 ? true : _props$fixed,
    popoverOverlayClassName = props.popoverOverlayClassName;
  var calcStyle = function calcStyle() {
    var defaultFixedPosition = {
      top: '50%',
      transform: 'translateY(-50%)',
      right: '10px',
      position: 'fixed'
    };
    if (!fixed) {
      return style;
    }
    return Object.assign(defaultFixedPosition, style);
  };
  var renderContent = function renderContent() {
    if (children) {
      return children;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "dr-feedback-inner"
    }, /*#__PURE__*/React.createElement("img", {
      className: "dr-feedback-inner-icon",
      src: "https://hwobs.fanruan.com/ui/digit-fe/feedback/customer.png"
    }), /*#__PURE__*/React.createElement("div", null, "\u8054\u7CFB\u6211\u4EEC"));
  };
  return /*#__PURE__*/React.createElement(MediaContextProvider, null, /*#__PURE__*/React.createElement(ComponentWrapper, null, /*#__PURE__*/React.createElement(Popover, {
    open: hovered,
    onOpenChange: function onOpenChange(isOpen) {
      setHovered(isOpen);
    },
    overlayClassName: cx(popoverOverlayClassName, 'dr-feedback-popover-wrapper'),
    placement: "left",
    content: /*#__PURE__*/React.createElement(FeedbackPopover, _extends({
      onClose: function onClose() {
        setHovered(false);
      }
    }, props))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(className, 'dr-feedback'),
    style: calcStyle()
  }, renderContent())), haveBacktop && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(FeedbackBackTop, {
    onBacktopClick: function onBacktopClick() {
      setHovered(false);
    }
  }), document.body)));
};
Feedback.FeedbackBtn = FeedbackBtn;
export default Feedback;